import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';
import Covid19Constants from '../../../common/Covid19Constants';
import Covid19Utils from '../../../common/Covid19Utils';
import Covid19Action from '../../../redux/actions/Covid19Action';
import { ConfigSelector } from '../../../redux/reducers/ConfigReducer';
import { PlansSelector } from '../../../redux/reducers/PlansReducer';
import FormTextareaContainer from '../../../redux/containers/FormTextareaContainer';
import FormDropdownContainer from '../../../redux/containers/FormDropdownContainer';
import Covid19Tickbox from './Covid19Tickbox';
import './Covid19Confirmation.scss';

const covid19Name = Covid19Constants.signup.propertyName;
const covid19Msg1 = Covid19Constants.signup.message1;
const covid19Msg2 = Covid19Constants.signup.message2;
const covid19Label = Covid19Constants.signup.label;

const Covid19Confirmation = (props) => {
  const { lockDownEndDate, isEssentialService, provider } = props;
  return (
    <div>
      {isEssentialService &&
      <div className="essential-question-section">
        <FormDropdownContainer
          name="essentialServiceType"
          items={Covid19Constants.signup.essentialServiceType.types}
          className="autotest-essential-service-types skinny-dropdown essential-business-category"
          label={Covid19Constants.signup.essentialServiceType.label}
          placeholder={Covid19Constants.signup.essentialServiceType.placeholder}
        />
        <FormTextareaContainer
          name="essentialServiceReason"
          label={Covid19Constants.signup.essentialServiceReason.label}
          placeholder={Covid19Constants.signup.essentialServiceReason.placeholder}
          maxLength={200}
          rows={3}
        />
        {/* {Covid19Utils.isChorus(provider) &&
        <span className="bold text-smaller">
          {Covid19Constants.signup.chorusMessage1 + Covid19Utils.getFormattedLockDownEndDate(lockDownEndDate)
          + Covid19Constants.signup.chorusMessage2}
        </span>
        } */}
      </div>
      }
      {Covid19Utils.showCovid19CheckBox(lockDownEndDate, provider) &&
      <div className="covid-19-confirmation-text">
        <p>{covid19Msg1}</p>
        <p>{covid19Msg2}</p>
        <Field
          id={covid19Name}
          name={covid19Name}
          label={covid19Label}
          component={Covid19Tickbox}
          props={props}
        />
      </div>
      }
    </div>
  );
};

const formSelector = formValueSelector('checkout');
const mapStateToProps = state => ({
  lockDownEndDate: ConfigSelector.getLockDownEndDate(state),
  isEssentialService: formSelector(state, 'isEssentialService'),
  provider: PlansSelector.getProvider(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    handleChange: Covid19Action.updatedNoCovid19Confirmed
  }, dispatch);

Covid19Confirmation.propTypes = {
  lockDownEndDate: PropTypes.instanceOf(Date),
  provider: PropTypes.string,
  isEssentialService: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(Covid19Confirmation);



/** WEBPACK FOOTER **
 ** ./src/components/checkout/PreferredConnectionDate/Covid19Confirmation.js
 **/